import { memo } from "react";
function LogoutIcon({ color = "#05A792", height, width }) {
  return (
    <svg
      width={width ?? "15"}
      height={height ?? "15"}
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.25 25.65C25.95 25.35 25.8 24.9833 25.8 24.55C25.8 24.1167 25.95 23.7667 26.25 23.5L30.25 19.5H14.25C13.8167 19.5 13.4583 19.3583 13.175 19.075C12.8917 18.7917 12.75 18.4333 12.75 18C12.75 17.5667 12.8917 17.2083 13.175 16.925C13.4583 16.6417 13.8167 16.5 14.25 16.5H30.15L26.1 12.45C25.8333 12.1833 25.7 11.8417 25.7 11.425C25.7 11.0083 25.85 10.65 26.15 10.35C26.45 10.05 26.8083 9.9 27.225 9.9C27.6417 9.9 28 10.05 28.3 10.35L34.95 17C35.1167 17.1667 35.2333 17.3333 35.3 17.5C35.3667 17.6667 35.4 17.85 35.4 18.05C35.4 18.25 35.3667 18.4333 35.3 18.6C35.2333 18.7667 35.1167 18.9333 34.95 19.1L28.35 25.7C28.0833 25.9667 27.7417 26.1 27.325 26.1C26.9083 26.1 26.55 25.95 26.25 25.65ZM3 36C2.2 36 1.5 35.7 0.9 35.1C0.3 34.5 0 33.8 0 33V3C0 2.2 0.3 1.5 0.9 0.9C1.5 0.3 2.2 0 3 0H16.05C16.4833 0 16.8417 0.141667 17.125 0.425C17.4083 0.708333 17.55 1.06667 17.55 1.5C17.55 1.93333 17.4083 2.29167 17.125 2.575C16.8417 2.85833 16.4833 3 16.05 3H3V33H16.05C16.4833 33 16.8417 33.1417 17.125 33.425C17.4083 33.7083 17.55 34.0667 17.55 34.5C17.55 34.9333 17.4083 35.2917 17.125 35.575C16.8417 35.8583 16.4833 36 16.05 36H3Z"
        fill={color}
      />
    </svg>
  );
}

export default memo(LogoutIcon);
